import type { QueryClient } from '@tanstack/react-query';
import type { GetEventSettingsDto } from '@/types/dtos/events/response/get-event-settings.dto';
import type { EventMediaSettingsDto } from '@/types/dtos/media/media-settings.dto';
import { GET_EVENT_SETTINGS_QUERY_KEY } from '@/state/queries/events/use-get-event-settings';
import { GET_FLOW_QUERY_KEY } from '@/state/queries/flows/use-get-flow';
import { GET_EVENT_FLOWS_QUERY_KEY } from '@/state/queries/flows/use-get-event-flows';

export type PatchEventMediaSettingsResponse = {
  mediaSettings: EventMediaSettingsDto;
  effectiveMediaSettings: EventMediaSettingsDto;
};

export function mergeEventMediaSettingsInSettingsQueryCache(
  queryClient: QueryClient,
  eventId: string,
  response: PatchEventMediaSettingsResponse,
) {
  queryClient.setQueryData<GetEventSettingsDto | null>([GET_EVENT_SETTINGS_QUERY_KEY, eventId], (old) =>
    old
      ? {
          ...old,
          mediaSettings: response.mediaSettings,
          effectiveMediaSettings: response.effectiveMediaSettings,
        }
      : old,
  );
}

/** Recompute flow effective media + capabilities after event host policy changes. */
export async function refetchFlowsAfterEventMediaSettingsChange(queryClient: QueryClient) {
  await Promise.all([
    queryClient.refetchQueries({ queryKey: [GET_FLOW_QUERY_KEY], type: 'active' }),
    queryClient.refetchQueries({ queryKey: [GET_EVENT_FLOWS_QUERY_KEY], type: 'active' }),
  ]);
}
